import React from "react";
import DraftGeneration from "../../components/DraftGeneration/DraftGeneration";

const  DraftGenerationMain: React.FC = () => {
    return (
        <>
            <DraftGeneration />
        </>
    )
}

export default  DraftGenerationMain